<template>
  <div class="page">
    <vue-topprogress ref="topProgress"></vue-topprogress>
    <transition-group id="components" name="component" tag="div" class="component_list" :class="[id, viewClass]">
      <ObjectLoader :object="object" :position="index" :connection="object.connection" :plkparams="object.plkparams" :instance="getInstance(object.type)" v-for="(object, index) in componentsWithInstance" :key="`${Math.random()}-${index}`"/>
    </transition-group>
    <div v-if="showMarkwater" class="watermark">PLAKA - Design mode</div>
  </div>
</template>

<script>
import Vue from 'vue'
import async from 'async-es'
import ObjectLoader from './components/ObjectLoader/Index'
import { LOG_SUCCESS, LOG_ERROR } from '@/services'
import { ABOUT_VIEW } from '@/router'
import { DESIGN } from '@/store'
import { vueTopprogress } from 'vue-top-progress'

export default {
  name: 'designviewer',
  components: {
    vueTopprogress,
    ObjectLoader
  },
  data () {
    return {
      instances: {},
      view: {},
      id: this.$route.params.id || 'index',
      executingActions: true,
      showMarkwater: window.PLKDesign
    }
  },
  metaInfo () {
    return this.view.metaInfo || {}
  },
  beforeDestroy () {
    this.$servicesPLK.event.emitEvent(this.$servicesPLK.event.BASIC_ACTIONS.DESTROY, {})
  },
  computed: {
    components () {
      return this.view.components || []
    },
    viewClass () {
      return this.view.viewClass || ''
    },
    componentsWithInstance () {
      return this.executingActions ? [] : this.components.filter(object => this.getInstance(object.type))
    }
  },
  watch: {
    components () {
      this.loadComponents()
    },
    $route (to, from) {
      window.scrollTo(0, 0)
      Vue.set(this, 'id', to.params.id)
      this.$servicesPLK.event.emitEvent(this.$servicesPLK.event.BASIC_ACTIONS.DESTROY, {})
      this.onInitComponent()
    }
  },
  methods: {
    onInitComponent () {
      this.loadView()
      this.injectJavascript({ content: this.$store.getters[DESIGN.GETTERS.GET_JAVASCRIPT]() })
      this.injectStyle({ content: this.$store.getters[DESIGN.GETTERS.GET_STYLE]() })
    },
    loadView () {
      this.$refs.topProgress.start()
      Vue.set(this, 'executingActions', true)
      this.$servicesPLK.component.getView(this.id).then(async (view) => {
        this.$servicesPLK.logger.log(this.id, `${this.id}-loadPage-200`, LOG_SUCCESS)
        Vue.set(this, 'view', (view || {}))
        await this.executeActions(view.actions)
        Vue.set(this, 'executingActions', false)
        this.$refs.topProgress.done()
      }).catch(() => {
        this.$refs.topProgress.fail()
        this.$servicesPLK.logger.log(this.id, `${this.id}-loadPage-404`, LOG_ERROR)
        this.$router.push({ name: ABOUT_VIEW, query: this.$route.query })
      })
    },
    executeActions (actions = []) {
      // Esta función nos permite ejecutar acciones en paralelo o en serie segun un parametro order
      const key = 'order'
      const grouped = Object.values(actions.reduce((rv, x) => {
        (rv[x[key] || 0] = rv[x[key] || 0] || []).push(x)
        return rv
      }, {}))
      return async.series(grouped.map((group) => {
        return (serieResponse) => {
          async.parallel(group.map(e => (parallelResponse) => this.executeFunction(e.function, parallelResponse))).then(() => {
            serieResponse()
          })
        }
      }))
    },
    executeFunction (exec, resolve) {
      if (exec) {
        try {
          let fun = new Function(['ctx', 'resolve'], exec)
          return fun.apply(this, [this, resolve])
        } catch (e) {
          return exec
        }
      }
    },
    getInstance (type) {
      return this.instances[this.normalizeType(type)]
    },
    normalizeType (type) {
      return this.$servicesPLK.component.normalizeType(type)
    },
    loadComponents () {
      this.components.forEach((object) => {
        if (!object.type) {
          console.warn('No found type object')
        } else if (object.type && !this.instances[object.type]) {
          this.$servicesPLK.component.loadComponent(object.type, this.instances, this.normalizeType(object.type))
        }
      })
    },
    injectJavascript ({ id = 'javascriptCustom', content = '' }) {
      let head = document.head || document.getElementsByTagName('head')[0]
      let javascriptCustom = document.getElementById(id)
      if (javascriptCustom) {
        javascriptCustom.remove()
      }
      let script = document.createElement('script')
      script.setAttribute('id', id)
      script.type = 'text/javascript'
      script.appendChild(document.createTextNode(content))
      head.appendChild(script)
    },
    injectStyle ({ id = 'stylesCustom', content = '' }) {
      let head = document.head || document.getElementsByTagName('head')[0]
      let stylesCustom = document.getElementById(id)

      if (stylesCustom) {
        stylesCustom.innerText = content
      } else {
        let style = document.createElement('style')
        style.setAttribute('id', id)
        style.type = 'text/css'
        if (style.styleSheet) {
          // This is required for IE8 and below.
          style.styleSheet.cssText = content
        } else {
          style.appendChild(document.createTextNode(content))
        }
        head.appendChild(style)
      }
    }
  }
}
</script>
<style scoped>
  .watermark {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    padding: 10px 0px;
    background: #efefef66;
    text-align: center;
  }
</style>

<style lang="scss">
.component {
  /* &-move { transition: all 600ms ease-in-out 50ms } */
  /* &-enter-active { transition: all 300ms ease-out } */
  &-enter-active, &-leave-active {
    transition: opacity 1s
  }

  &-enter, &-leave-to /* &-leave-active in <2.1.8 */ {
    opacity: 0
  }

  &-leave-to { display: none }
  /* &-enter { opacity: 0 } */
  /* &-enter { transform: scale(0.95) } */
}
</style>
